import createPlugin from './pm-plugins/main';
import { pluginKey } from './pm-plugins/plugin-key';

/**
 * This plugin is aiming to improve undo behaviour for some of our more custom applications, very specific text
 * paste events, splitting blocks of text, new lines.
 */
var betterTypeHistoryPlugin = function betterTypeHistoryPlugin() {
  return {
    name: 'betterTypeHistory',
    actions: {
      flagPasteEvent: function flagPasteEvent(tr) {
        tr.setMeta(pluginKey, true);
        return tr;
      }
    },
    pmPlugins: function pmPlugins() {
      return [{
        name: 'betterTypeHistory',
        plugin: function plugin() {
          return createPlugin();
        }
      }];
    }
  };
};
export { betterTypeHistoryPlugin };